export default __webpack_public_path__ + "static/media/firstSection.bef1b612.jpg";